import { render, staticRenderFns } from "./RewardOptions.vue?vue&type=template&id=158884a4&"
import script from "./RewardOptions.vue?vue&type=script&lang=js&"
export * from "./RewardOptions.vue?vue&type=script&lang=js&"
import style0 from "./RewardOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports